module.exports = __webpack_public_path__ + "img/rcyc-aqsj.10567b3b.png";